import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'

Vue.component('ButtonLoader', require('./components/ButtonLoader.vue').default)
Vue.component('Pagination', require('./components/Pagination.vue').default)
Vue.filter('rupiah', function (value) {
  var val = parseInt(value)
  return val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
})

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})
